const req = require.context('.', true, /^(?!.\/index).*.js$/);

req.keys().forEach(key => {
  const componentName = key.replace(/^.+\/([^/]+)\.js/, '$1');
  module.exports[componentName] = req(key).default;
});



// WEBPACK FOOTER //
// ./src/script/components/index.js